import { InjectionToken } from '@angular/core';
import { Configuration } from './configuration';


export const VEDRAX_CONFIG = new InjectionToken<Configuration>('VEDRAX_CONFIG');